import { ComponentsModule } from '@app/modules/mazars-common/components/components.module';
import { MazarsCommonModule } from '@app/modules/mazars-common/mazars-common.module';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { UtilsModule } from '@shared/utils/utils.module';
import { CreateSupportTicketDialogComponent } from './support-tickets/create-support-ticket/create-dialog.component';
import { CreateSupportTicketFormComponent } from './support-tickets/create-support-ticket/create-form.component';
import { SupportTicketsService, SupportMessagesService, SupportDeskQuickLinkService } from './support.services';
import { FileUploadServiceProxy } from '@shared/service-proxies/general-proxies';
import { SupportQuickLinkComponent } from './support-desk/quicklink/support-quicklink.component';
import { SupportMessagesComponent } from './support-messages/support-messages.component';
import { SupportDeskTicketBaseComponent } from './support-desk/ticket/support-desk-ticket.component';
import { SupportQuickLinkErrorComponent } from './support-desk/quicklink/support-quicklink-error.component';

@NgModule({
    imports: [
    AppCommonModule,
    MazarsCommonModule,
    UtilsModule,
    AppSharedModule,
    CommonModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    CreateSupportTicketDialogComponent,
    CreateSupportTicketFormComponent,
    SupportQuickLinkComponent,
    SupportQuickLinkErrorComponent,
    SupportMessagesComponent,
    SupportDeskTicketBaseComponent,
],
    providers: [
        SupportTicketsService,
        SupportMessagesService,
        SupportDeskQuickLinkService,
        FileUploadServiceProxy,
    ],
    exports: [
        CreateSupportTicketFormComponent,
        CreateSupportTicketDialogComponent,
        SupportQuickLinkComponent,
        SupportQuickLinkErrorComponent,
        SupportMessagesComponent,
        SupportDeskTicketBaseComponent,
    ]
})
export class SupportSharedModule {}
